// import token from '../store/modules/token'
/**
 js bridge
 API:
 createNew()
 @class JsBridge
 */
import store from '../store/index'
var JsBridge = {
  type: 'JsBridge',
  onInit: null,
  createNew: function (onReady) {
    console.log('JsBridge.createNew')
    JsBridge.setupWebViewJavascriptBridge(function (bridge) {
      //
      try { // 此处try catch注意  android 有init初始化方法，必须调用 不调用后续注册的事件将无效 而IOS却没有init方法 调用会报错 所以得捕获异常
        bridge.init(function (message, responseCallback) {
          console.log('JS got a message', message)
          var data = {
            'Javascript Responds': '测试中文!'
          }
          console.log('JS responding with', data)
          responseCallback(data)
        })
      } catch (e) {

      }
      onReady(bridge)
    })
  },

  setupWebViewJavascriptBridge: function (callback) {
    var u = navigator.userAgent
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
    // var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
      JsBridge.setupWebViewJavascriptBridge4Android(callback)
    } else {
      JsBridge.setupWebViewJavascriptBridge4IOS(callback)
    }
  },

  setupWebViewJavascriptBridge4Android: function (callback) {
    console.log('setupWebViewJavascriptBridge4Android')
    if (window.WebViewJavascriptBridge) {
      return callback(window.WebViewJavascriptBridge)
    } else {
      document.addEventListener(
        'WebViewJavascriptBridgeReady',
        function () {
          return callback(window.WebViewJavascriptBridge)
        },
        false
      )
    }
  },

  setupWebViewJavascriptBridge4IOS: function (callback) {
    if (window.WebViewJavascriptBridge) {
      return callback(window.WebViewJavascriptBridge)
    }
    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback)
    }
    window.WVJBCallbacks = [callback]
    var WVJBIframe = document.createElement('iframe')
    WVJBIframe.style.display = 'none'
    WVJBIframe.src = 'https://__bridge_loaded__'
    document.documentElement.appendChild(WVJBIframe)
    setTimeout(function () {
      document.documentElement.removeChild(WVJBIframe)
    },
    0)
  }
}

var DFZHJsBridge = {
  disabled: true,
  type: 'DFZHJsBridge',
  onInit: null,
  createNew: function () {
    var ins = {}
    var prv = {}

    ins.jsBridge = null
    ins.imageEventCallback = null

    ins.init = function () {
      JsBridge.createNew(function (bridge) {
        console.log('bridge ready ' + JSON.stringify(bridge))
        prv.jsBridge = bridge
        prv.jsBridge.registerHandler('token', function (data, responseCallback) {
          const json = JSON.parse(data)
          console.log('response  token:' + json.token + ' version=' + json.version)
          store.commit('setInfo', { token: json.token, version: json.version })
          console.log('save token =' + store.state.token.token)
          responseCallback(0)
        })

        prv.jsBridge.registerHandler('addTmpImage', function (data, responseCallback) {
          const json = JSON.parse(data)
          console.log('response addTmpImage  resId=' + json.resId + ' resUrl=' + json.resUrl)
          if (ins.imageEventCallback) {
            ins.imageEventCallback({ resId: json.resId, resUrl: json.resUrl })
          }
          responseCallback(0)
        })

        prv.jsBridge.callHandler('getToken', null, function (responseData) {
          const json = JSON.parse(responseData)
          store.commit('setInfo', { token: json.token, version: json.version })
          console.log('getToken  save token =' + store.state.token.token)
        })

        prv.jsBridge.callHandler('getStatusBarHeight', null, function (responseData) {
          console.log('js update res ' + responseData)
        })
      })
    }

    ins.setAddImageCallback = function (callback) {
      ins.imageEventCallback = callback
    }

    ins.setBridge = function (bridge) {
      ins.jsBridge = bridge
    }

    ins.goBack = function () {
      if (prv.jsBridge) {
        console.log('callHandler: goBack')
        prv.jsBridge.callHandler('goBack', null, function (responseData) {
          console.log('response:' + responseData)
        })
      } else {
        console.log('back')
      }
    }

    ins.openCourseDetail = function (data) {
      if (prv.jsBridge) {
        console.log('callHandler: openCourseDetail')
        prv.jsBridge.callHandler('openCourseDetail', data, function (responseData) {
          console.log('response:' + responseData)
        })
      } else {
        console.log(data)
      }
    }

    ins.openCompass = function (data) {
      if (prv.jsBridge) {
        console.log('callHandler:openCompass')
        prv.jsBridge.callHandler('openCompass', data, function (responseData) {
          console.log('response:' + responseData)
        })
      }
    }

    ins.goLogout = function (data) {
      if (prv.jsBridge) {
        console.log('callHandler:goLogout')
        prv.jsBridge.callHandler('goLogout', data, function (responseData) {
          console.log('responseData' + responseData)
        })
      } else {
        console.log('callHandler  we should goLogout  but prv.jsBridge eq null')
      }
    }

    ins.goPay = function (data) {
      if (prv.jsBridge) {
        console.log('callHandler:goPay')
        prv.jsBridge.callHandler('goPay', data, function (responseData) {
          console.log('responseData' + responseData)
        })
      }
    }

    ins.openFile = function (data) {
      if (prv.jsBridge) {
        console.log('callHandler:openFile')
        prv.jsBridge.callHandler('openFile', data, function (responseData) {
          console.log('js bridge openFile responseData+' + responseData)
        })
      }
    }

    ins.openFileWithCode = function (data) {
      if (prv.jsBridge) {
        console.log('callHandler:openFileWithCode')
        prv.jsBridge.callHandler('openFileWithCode', data, function (responseData) {
          console.log('js bridge openFileWithCode res=' + responseData)
        })
      }
    }

    ins.share = function (data) {
      if (prv.jsBridge) {
        console.log('callHandler:share')
        prv.jsBridge.callHandler('share', data, function (responseData) {
          console.log('js share ' + responseData)
        })
      }
    }

    ins.update = function (data) {
      if (prv.jsBridge) {
        console.log('callHandler:update')
        prv.jsBridge.callHandler('update', data, function (responseData) {
          console.log('js update res ' + responseData)
        })
      }
    }

    ins.init()
    return ins
  }
}

export default DFZHJsBridge
